import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import AboutHero from './components/AboutHero';
import WhyChooseUs from './components/WhyChooseUs';
import TestimonialsGrid from './components/TestimonialsGrid';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-20">
        <AboutHero />
        <WhyChooseUs />
        <TestimonialsGrid />
      </main>
      <Footer />
    </div>
  );
};

export default AboutPage;
